const state = () => ({
    searchInfo: null,
});

const getters = {
    getSearchData: state => state.searchInfo,
};

const actions = {
    // 로그인 정보저장
    setSearchData({commit}, data){
        commit('SET_SEARCH_DATA', data);
    }
};

const mutations = {
    SET_SEARCH_DATA(state, payload) {
        state.searchInfo = payload;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
 